/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:49516206-7813-48a8-80f8-31ce15948ceb",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_6xtxFMkNW",
    "aws_user_pools_web_client_id": "r0k967k346i7ht7ep26gn602b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "braingames-storage2d476-dev",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
